import { NoResultsMessageProps } from './types';
import { noResultsHeading, noResultsHeading2 } from './constants';
import { humanizeSearchParams } from './humanizeSearchParams';
import { Cats } from '../../generated/static-categories';

const NoResultsMessage = ({ query, categoryGroupId, searchParams }: NoResultsMessageProps) => {
  const humanized = searchParams ? humanizeSearchParams(searchParams) : null;
  const catLabel = categoryGroupId ? Cats[categoryGroupId as keyof typeof Cats]?.label : null;
  const suffix = catLabel ? `in ${catLabel}` : 'listings';

  return (
    <span className="nothing">
      {noResultsHeading} {humanized || `'${query}'`}. {noResultsHeading2}
      {suffix}
    </span>
  );
};

export default NoResultsMessage;
